module.exports = __webpack_public_path__ + "img/CormidiDumper.0efc69b8.jpg";